export const LogoMark = ({ size = 34, className = "" }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
        className={className}
        aria-hidden="true"
    >
        <circle cx="32" cy="32" r="21" stroke="#D4AF37" strokeWidth="2.5" />
        <g stroke="#D4AF37" strokeWidth="2.2" strokeLinecap="round">
            <line x1="53" y1="32" x2="36.5" y2="39.8" />
            <line x1="42.5" y1="50.2" x2="27.5" y2="39.8" />
            <line x1="21.5" y1="50.2" x2="23" y2="32" />
            <line x1="11" y1="32" x2="27.5" y2="24.2" />
            <line x1="21.5" y1="13.8" x2="36.5" y2="24.2" />
            <line x1="42.5" y1="13.8" x2="41" y2="32" />
        </g>
        <circle cx="32" cy="32" r="4.5" fill="#D4AF37" />
    </svg>
);
